import type { RouteObject } from 'react-router-dom';
import { MembersPage } from '../features/members/MembersPage';
import { ApiKeysPage } from '../features/apikeys/ApiKeysPage';
import { AuditPage } from '../features/audit/AuditPage';
import { PartnerPageEditor } from '../features/partner-page/PartnerPageEditor';
import { FieldHomePage } from '../features/field/FieldHomePage';
import { ActivatePage } from '../features/field/ActivatePage';
import { OrgsPage } from '../features/operator/OrgsPage';
import { OrgDetailPage } from '../features/operator/OrgDetailPage';
import { DomainsPage } from '../features/operator/DomainsPage';
import { MigrationPage } from '../features/operator/MigrationPage';
import { QrsOperatorPage } from '../features/operator/QrsOperatorPage';
import { OpsConfigPage } from '../features/operator/OpsConfigPage';
import { QrAuditPage } from '../features/audit/QrAuditPage';
import { InvitationPage } from '../features/invitation/InvitationPage';

/** Hijos de `/consola`: equipo, integraciones, auditoría y página del partner (F1.T8, F2.T6, F8.T3, F6.T3). */
export const consolaEquipoRoutes: RouteObject[] = [
  { path: 'miembros', element: <MembersPage /> },
  { path: 'api-keys', element: <ApiKeysPage /> },
  { path: 'auditoria', element: <AuditPage /> },
  { path: 'pagina', element: <PartnerPageEditor /> },
];

/** Hijos de `/terreno`: app del vendedor (F5.T4). */
export const terrenoRoutes: RouteObject[] = [
  { index: true, element: <FieldHomePage /> },
  { path: 'activar', element: <ActivatePage /> },
  { path: 'activar/:code', element: <ActivatePage /> },
];

/** Hijos de `/operador`. */
export const operadorRoutes: RouteObject[] = [
  { path: 'organizaciones', element: <OrgsPage /> },
  { path: 'organizaciones/:orgId', element: <OrgDetailPage /> },
  { path: 'qr', element: <QrsOperatorPage /> },
  { path: 'qr/:code/auditoria', element: <QrAuditPage /> },
  { path: 'configuracion', element: <OpsConfigPage /> },
  { path: 'dominios', element: <DomainsPage /> },
  { path: 'migracion', element: <MigrationPage /> },
];

/** Rutas públicas fuera de los layouts autenticados. */
export const publicRoutes: RouteObject[] = [{ path: '/invitacion', element: <InvitationPage /> }];
